import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngxs/store';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  PrivilegeCategory,
  Privilege,
  RolePrivilege,
  RolePrivilegePending,
} from 'src/app/components/catalogs/roles/services/role-privilege';
import { utils } from 'src/app/modules/libs/utils';
import { Role } from '../../services/role';
import { PrivilegeEnum } from 'src/app/common/enumerations/privilege-enum';

@Component({
  selector: 'role-privilege-add',
  templateUrl: './role-privilege-add.component.html',
  styleUrls: ['./role-privilege-add.component.scss'],
})
export class RolePrivilegeAddComponent implements OnInit, OnDestroy {
  privilegeCategory!: PrivilegeCategory;
  privilegeCategories!: PrivilegeCategory[];
  privilegeCategoriesFiltered!: PrivilegeCategory[];
  privilegeCategories$!: Observable<PrivilegeCategory[]>;
  privilegeCategoriesSubs!: Subscription;

  privilege!: Privilege;
  privileges!: Privilege[];
  privilegesFiltered!: Privilege[];
  selectedPrivileges: RolePrivilegePending[] = [];
  selectedPrivilegeIds: PrivilegeEnum[] = [];

  rolePrivileges?: RolePrivilege[];
  rolePrivilegesFiltered?: RolePrivilege[];
  rolePrivilegesSubs!: Subscription;
  rolePrivilegesSelected?: RolePrivilege[];
  role?: Role;

  categoryId?: number;
  disableCategory?: boolean;

  constructor(
    private store: Store,
    public dialogRef: MatDialogRef<RolePrivilegeAddComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      role: Role;
      rolePrivileges: RolePrivilege[];
      categoryId: number;
    },
  ) {
    this.role = data.role;
    this.rolePrivileges = data.rolePrivileges;
    this.rolePrivilegesFiltered = this.role?.rolePrivileges;
    this.selectedPrivilegeIds =
      this.rolePrivileges
        .filter((rp) => rp.pendingClass != 'red')
        ?.map((rp) => rp.privilege) ?? [];
    this.categoryId = data.categoryId;
    this.disableCategory = !!data.categoryId;
  }

  ngOnDestroy(): void {
    this.privilegeCategoriesSubs?.unsubscribe();
    this.rolePrivilegesSubs?.unsubscribe();
  }

  ngOnInit(): void {
    this.loadRolePrivileges();
    this.loadPrivilegeCategories();
  }

  loadRolePrivileges() {
    this.rolePrivilegesFiltered = this.role?.rolePrivileges;
    this.selectedPrivilegeIds =
      this.role?.rolePrivilegesPending?.map((rpp) => rpp.privilege) ?? [];

    // this.rolePrivilegesSubs = this.store.select(state => state.RolePrivileges.data).subscribe(data => {
    //   if (data?.length) {
    //     this.rolePrivileges = data;
    //     this.rolePrivilegesFiltered = this.role?.rolePrivileges;
    //     this.selectedPrivilegeIds = this.role?.rolePrivilegesPending?.map(rpp => rpp.privilege) ?? [];
    //   }
    // });
  }

  loadPrivilegeCategories() {
    this.privilegeCategories$ = this.store.select(
      (state) => state.PrivilegeCategories.data,
    );
    this.privilegeCategoriesSubs = this.privilegeCategories$.subscribe(
      (data) => {
        this.privilegeCategories = data;
        this.privilegeCategoriesFiltered = this.privilegeCategories.sort(
          (a, b) => utils.sort(a.name, b.name),
        );
        if (this.categoryId) this.selectedCategory(this.categoryId);
      },
    );
  }

  displayObject(e: any) {
    return e ? e.name : null;
  }

  getSelectedPrivileges() {
    return this.selectedPrivileges.map((p) => p.privilege);
  }

  changedCategory(e: any) {
    const text = e.target.value as string;
    this.privilegeCategoriesFiltered = this.privilegeCategories
      .filter(
        (x) =>
          x.name?.toLowerCase().includes(text.toLowerCase()) ||
          x.code?.toLowerCase().includes(text.toLowerCase()),
      )
      .sort((a, b) => utils.sort(a.name, b.name));
  }

  changedPrivilege(e: any) {
    const text = e.target.value as string;
    this.privilegesFiltered = this.privileges
      .filter(
        (x) =>
          x.name?.toLowerCase().includes(text.toLowerCase()) ||
          x.code?.toLowerCase().includes(text.toLowerCase()),
      )
      .sort((a, b) => utils.sort(a.name, b.name))
      .sort((a, b) => utils.sort(a.name, b.name));
  }

  selectedCategory(id: any) {
    this.privilegeCategory = this.privilegeCategories.find((c) => c.id == id)!;
    this.privileges = this.privilegeCategory.privileges;
    this.rolePrivilegesFiltered = this.rolePrivileges?.filter(
      (rp) =>
        rp.roleID == this.role?.id &&
        this.privileges.map((p) => p.privilegeEnum).includes(rp.privilege),
    );
    this.selectedPrivilegeIds =
      this.rolePrivileges
        ?.filter(
          (rp) =>
            rp.privilegeObj?.privilegeCategoryID == this.privilegeCategory.id &&
            rp.pendingClass != 'red',
        )
        ?.map((rp) => rp.privilege) ?? [];
  }

  selectedPriv(e: any) {
    this.privilege = e.option.value;
  }

  optionToggled(e: any, p: Privilege) {
    if (e.isUserInput) {
      const selected = e.source.selected;
      this.selectedPrivileges.push({
        privilege: e.source.value,
        selected,
        roleID: this.role?.id!,
      });
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  accept() {
    this.dialogRef.close(this.selectedPrivileges);
  }

  lookupName = (id: number) =>
    this.privileges?.find((p) => p.id === id)?.name ?? String(id);
}
